import { Injectable, inject } from '@angular/core';

import { AuthService } from '../auth/auth.service';
import {
  EMPRESA_LABEL_OVERRIDES,
  LABEL_DEFAULTS,
} from '../../config/empresa-label-overrides';

// Resolve labels per-tenant via mapa estatico em config/empresa-label-overrides.ts.
// Le a empresa logada do AuthService.empresaSelecionada$. Lookup eh O(1) e nao
// faz I/O — pode ser chamado com seguranca de pipes impuros.
//
// O GUID eh normalizado para minusculas antes do lookup: o SQL Server guarda o
// uniqueidentifier em MAIUSCULAS e, dependendo da serializacao, a API pode
// devolver em qualquer caixa. As keys de EMPRESA_LABEL_OVERRIDES sao sempre
// minusculas — sem essa normalizacao o override silenciosamente nao casava.
@Injectable({ providedIn: 'root' })
export class LabelService {
  private authService = inject(AuthService);

  get(key: string): string {
    const guid = this.authService.empresaSelecionada$.getValue()?.guid;
    if (guid) {
      const override = EMPRESA_LABEL_OVERRIDES[guid.toLowerCase()];
      if (override && override[key] !== undefined) return override[key];
    }
    return LABEL_DEFAULTS[key] ?? key;
  }
}
